import { SiteLink as Link } from './SiteLink';
import { linkProps } from '../lib/links';
import { BLOG_PATH, FOUNDER_BLOG_URL } from '../lib/appUrls';

const groups = [
  {
    label: 'Product',
    links: [
      { label: 'Per-tool access', href: '/#per-tool' },
      { label: 'Pricing', href: '/pricing' },
      { label: 'Documentation', href: 'https://docs.statio.dev/docs/' },
      { label: 'Getting Started', href: '/getting-started' },
      { label: 'Download', href: '/download' },
      { label: 'Security', href: '/security' },
      { label: 'MCP server catalog', href: '/mcp-servers' },
      { label: 'mcp-gen', href: '/mcp-gen' },
    ],
  },
  {
    label: 'Guides',
    links: [
      { label: 'What is an MCP server?', href: '/tutorials/what-is-mcp' },
      { label: 'MCP security checklist', href: '/tools/mcp-security-checklist' },
      { label: 'MCP permissions', href: '/mcp-permissions' },
      { label: 'Agent identity', href: '/mcp-agent-identity' },
      { label: 'Audit logs', href: '/mcp-audit-logs' },
      { label: 'Self-hosted gateway', href: '/self-hosted-mcp-gateway' },
    ],
  },
  {
    label: 'Compare',
    links: [
      { label: 'Runlayer alternative', href: '/compare/runlayer-alternative' },
      { label: 'Natoma alternative', href: '/compare/natoma-alternative' },
      { label: 'TrueFoundry alternative', href: '/compare/truefoundry-alternative' },
      { label: 'Statio vs DIY', href: '/compare/statio-vs-diy' },
      { label: 'Statio vs raw MCP', href: '/compare/statio-vs-raw-mcp' },
    ],
  },
  {
    label: 'Company',
    links: [
      { label: 'About', href: '/about' },
      { label: 'Blog', href: BLOG_PATH },
      { label: 'Tutorials', href: '/tutorials' },
      { label: "Founder's blog", href: FOUNDER_BLOG_URL },
      { label: 'Contact', href: 'mailto:dans@romans.dev' },
      { label: 'SID Technologies', href: 'https://romans.dev' },
    ],
  },
  {
    label: 'Legal',
    links: [
      { label: 'Privacy Policy', href: '/privacy' },
      { label: 'Terms of Service', href: '/terms' },
    ],
  },
];

function FooterLink({ label, href }: { label: string; href: string }) {
  const p = linkProps(href);
  if (p.to) return <Link to={p.to}>{label}</Link>;
  return (
    <a href={p.href} target={p.external ? '_blank' : undefined} rel={p.external ? 'noopener noreferrer' : undefined}>
      {label}
    </a>
  );
}

export function Footer() {
  return (
    <footer className="s-foot">
      <div className="s-wrap">
        <div className="cols">
          <div>
            <span className="s-logo">Statio</span>
            <p className="blurb">
              An MCP gateway that controls access one tool at a time and gives every AI agent its own identity.
            </p>
          </div>
          {groups.map((g) => (
            <nav key={g.label} aria-label={g.label}>
              <h2>{g.label}</h2>
              <ul>
                {g.links.map((l) => (
                  <li key={l.label}>
                    <FooterLink {...l} />
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>
        <div className="legal">
          <span>&copy; 2026 Statio. A product of SID Technologies.</span>
          <span>Paintings: The Metropolitan Museum of Art, Open Access (CC0)</span>
        </div>
      </div>
    </footer>
  );
}
